var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAddMemberIconinline = function SvgAddMemberIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4h1v7h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 7v1h-7V7zM9 9a4.5 4.5 0 100-9 4.5 4.5 0 000 9m9 7.875V18H0v-1.125a6.75 6.75 0 015.476-6.626 6.705 6.705 0 007.048 0A6.75 6.75 0 0118 16.875"
  }))));
};
export default SvgAddMemberIconinline;